import React from "react";
import { useTranslation } from "react-i18next";
import millify from "millify";
import { useState } from "react";
import Highcharts from "highcharts";
import { Dropdown } from "primereact/dropdown";
import HighchartsReact from "highcharts-react-official";
import { AppContext, API } from "../../utils";
import html2canvas from "html2canvas";
import DropdownImg from "../../images/dropdown1.png";

import { ReactComponent as UpIcon } from "../../images/upIcon.svg";
import { ReactComponent as DownIcon } from "../../images/downIcon.svg";

const SpLineFansPost = (props) => {
  const [state, setState] = React.useContext(AppContext);
  function convert_format_date(date_to_convert) {
    let date = new Date(date_to_convert);

    // Get year, month, and day part from the date
    let year = date.toLocaleString("default", { year: "numeric" });
    let month = date.toLocaleString("default", { month: "2-digit" });
    let day = date.toLocaleString("default", { day: "2-digit" });

    // Generate yyyy-mm-dd date string
    let formattedDate = year + "-" + month + "-" + day;
    return formattedDate;
  }
  const { t, i18n } = useTranslation();

  function day_or_month(date_one, date_two) {
    let date1 = new Date(date_one);
    let date2 = new Date(date_two);

    let diffTime = Math.abs(date2 - date1);
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    let type = " ";
    if (diffDays <= 31) {
      type = "day";
    } else {
      type = "month";
    }

    return type;
  }

  let date_form = convert_format_date(state.reportingPeriod[0].toDateString());
  let date_to = convert_format_date(state.reportingPeriod[1].toDateString());

  const [type_option, setType_option] = useState(
    day_or_month(date_form, date_to)
  );
  const [valueDropdownOption, setValueDropdownOption] = useState(
    day_or_month(date_form, date_to)
  );

  let options = {
    credits: false,

    chart: {
      type: "spline",
      zoomType: "xy",
      style: {
        fontFamily: "Inter",
      },
    },
    title: {
      text: t("Performance_report.posts_reach"),
      align: "left",
      margin: 50,
    },
    subtitle: {
      text: t("Performance_report.posts_reach_desc"),
      align: "left",
      margin: 50,
    },
    xAxis: {
      categories: [],
      accessibility: {
        description: "Months of the year",
      },
    },
    yAxis: {
      title: {
        text: "",
      },
      labels: {
        formatter: function () {
          return this.value + "";
        },
      },
    },
    tooltip: {
      crosshairs: true,
      shared: true,
    },
    plotOptions: {
      spline: {
        lineWidth: 4,
        marker: {
          radius: 4,
          //   lineColor: "#596ae9",
          lineWidth: 1,
          enabled: false,
        },
      },
    },
    series: [{}],
  };

  //-- day data
  const day_array = [];
  const day_array_posts_reach_organic = [];
  const day_array_posts_reach_paid = [];
  const propsDay = Object.entries(props.data.by_day);
  
  const propsDayReel = Object.entries(props.data.post_type.reels.by_day);

/* for (const [key, value] of Object.entries(propsDay)) {
    day_array.push(value[0]);
    day_array_posts_reach_organic.push(value[1].posts_reach_organic ?? 0);
    day_array_posts_reach_paid.push(value[1].posts_reach_paid ?? 0);
  }*/
  // Vérifiez si les deux ensembles de données ont la même longueur
if (propsDay.length === propsDayReel.length) {
  for (let i = 0; i < propsDay.length; i++) {
    const [key, value] = propsDay[i];
    const [keyReel, valueReel] = propsDayReel[i];

    if (key === keyReel) { // Vérifiez si les clés sont les mêmes
      day_array.push(key);
      day_array_posts_reach_organic.push((value.posts_reach_organic ?? 0) + (valueReel.total_reach_reel_organic ?? 0));
      day_array_posts_reach_paid.push((value.posts_reach_paid ?? 0) + (valueReel.total_reach_reel_paid ?? 0));
    }
  }
}

  const day_posts_reach_organic = {
    name: t("Performance_report.posts_reach_organic"),
    data: day_array_posts_reach_organic,
  };
  const day_posts_reach_paid = {
    name: t("Performance_report.posts_reach_paid"),
    data: day_array_posts_reach_paid,
  };

  function sort_array(dates) {
    dates.sort(function (a, b) {
      let dateA = new Date(a);
      let dateB = new Date(b);
      return dateA - dateB;
    });
    return dates;
  }

  function day_data_option() {
    options.series.push(day_posts_reach_organic);
    options.series.push(day_posts_reach_paid);
    sort_array(day_array).map((entry, index) => {
      options.xAxis.categories.push(entry);
    });
  }

  //-- month data
 const myData = props.cmpData.data;
 const myData_Reel = props.data.post_type.reels.by_month;
 if (myData_Reel && typeof myData_Reel === 'object') {
  // Convert the object keys into an array
  const keysArray = Object.keys(myData_Reel);

  // Then, you can use map on the keysArray to access each value
  const reels_reach_organic_array = keysArray.map((key) => myData_Reel[key].total_reach_reel_organic);
  
}
 
   const posts_reach_organic_array = myData.map(
    (item) => (item.posts_reach_organic)
  );
  
 /* const reelReach = item.props.data.post_type.reels.by_month.total_reach_reel_organic ?? 0;
  console.log(reelReach);
  const total_reach_array = myData.map(item => {
    const reelReach = item.props.data.post_type.reels.by_month.total_reach_reel_organic_month ?? 0;
   // const postReach = item.posts_reach_organic ?? 0;
    return reelReach;
  });*/
  

  const posts_reach_organic = {
    name: "posts reach organic",
    data: posts_reach_organic_array,
    
  };

  const posts_reach_paid_array = myData.map((item) => item.posts_reach_paid);
  const posts_reach_paid = {
    name: "posts reach paid",
    data: posts_reach_paid_array,
  };

  const status = [
    { name: t("Options.month"), code: "month" },
    { name: t("Options.day"), code: "day" },
  ];

  function month_data_option() {
    options.series.push(posts_reach_organic);
    options.series.push(posts_reach_paid);
    props.cmpData.data.map((entry, index) => {
      options.xAxis.categories.push(entry.name);
    });
  }

  //-- option
  type_option === "month" ? month_data_option() : day_data_option();
  const onOptionChange = (e) => {
    setValueDropdownOption(e.value);
    if (e.value === "month") setType_option("month");
    if (e.value === "day") setType_option("day");
  };

  function remove_empty_value(arr) {
    var index;
    arr.some(function (obj, i) {
      return Object.keys(obj).length === 0 && obj.constructor === Object
        ? ((index = i), true)
        : false;
    });
    arr.shift(index);
    return index;
  }
  remove_empty_value(options.series);

  const previous_end_date = props.data.date_info.previous_end_day ?? 0;
  const previous_start_date = props.data.date_info.previous_start_day ?? 0;

  const previous_total = props.data.total.previous_total;
  const variation_reachs = props.data.total.previous_total.variation_reachs;
  const variation_posts_reach_organic =
    previous_total.previous_posts_reach_organic
      ? ((props.data.total.posts_reach_organic -
          previous_total.previous_posts_reach_organic) /
          previous_total.previous_posts_reach_organic) *
          100 ?? 0
      : 0;
  const variation_posts_reach_paid = previous_total.previous_posts_reach_paid
    ? ((props.data.total.posts_reach_paid -
        previous_total.previous_posts_reach_paid) /
        previous_total.previous_posts_reach_paid) *
        100 ?? 0
    : 0;

  const printChart = (event) => {
    event.preventDefault();

    let target = event.target;
    let parent = target.parentElement.parentElement;
    let name = parent.getAttribute("data-value");
    parent.classList.add("capture_style");

    html2canvas(parent, {
      onclone: (document) => {},
    }).then((canvas) => {
      const data = canvas.toDataURL("image/jpg");
      const link = document.createElement("a");

      if (typeof link.download === "string") {
        link.href = data;
        link.download = name + ".jpg";

        parent.classList.remove("capture_style");

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        window.open(data);
      }
    });
  };
const hasDataOptions = 
    Array.isArray(options.series) &&
    options.series.length > 0 &&
    options.series.some(serie => Array.isArray(serie.data) && serie.data.length > 0);
  return (
    <div>
      <div className="highchart_block">
        <div data-value="Croissance Portée" className="highchart_block1">
          <div data-html2canvas-ignore className="flex items-center">
            <div className="flex items-center ml-auto border rounded-md capitalize">
              <img src={DropdownImg} className="pl-2" alt="DropdownImg" />
              <Dropdown
                value={valueDropdownOption}
                options={status}
                onChange={onOptionChange}
                defaultValue={setType_option}
                optionLabel="name"
                optionValue="code"
                placeholder="Choisir"
                className="font-medium"
              />
            </div>

            <button
              onClick={printChart}
              className="mx-5 w-5 h-5 print_capture"
            ></button>
          </div>
          {!hasDataOptions && (
            <div className="text-red-500 font-semibold mb-2 ml-2">
                {t("Performance_report.no_posts_reach_for_this_period") || "Aucune donnée disponible pour cette période"}
              </div>
            )}
          <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
      </div>
    </div>
  );
};
export default SpLineFansPost;
